import { render, staticRenderFns } from "./VasLoginModal.vue?vue&type=template&id=b54f0b94"
import script from "./VasLoginModal.vue?vue&type=script&lang=js"
export * from "./VasLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports